import React from 'react'
import topFrameImage from '../../assets/images/topFrame.svg'
import bottomFrameImage from '../../assets/images/bottomFrame.png'

const LiftPage: React.FC = () => (
  <div className="bg-white rounded-[24px] w-[35%] h-[clamp(500px,96vh,900px)] m-[clamp(8px,1.25vw,20px)] flex flex-col justify-between p-[clamp(4px,0.5vw,8px)]">
    {/* Top frame */}
    <div className="flex justify-center items-center flex-1">
      <img 
        src={topFrameImage} 
        alt="Top Frame" 
        className="w-full h-auto max-h-[clamp(150px,35vh,280px)] object-contain"
      />
    </div>
    
    {/* Bottom frame */}
    <div className="flex justify-center items-end flex-1  ">
      <img 
        src={bottomFrameImage} 
        alt="Bottom Frame" 
        className="w-full  object-cover rounded-[clamp(12px,1.5vw,24px)]"
      />
    </div>
  </div>
)

export default LiftPage
